import axios from 'axios'

// const token = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1SWQiOiJCMTQ1MTkiLCJuYW1lIjoiTmd1eeG7hW4gVsSDbiBEIiwiZ2VuZGVyIjoiRV9GRU1BTEUiLCJkYXRhIjoiNTFMeXVzdGpIQnJsYnBKaGdvNDBtZWJFczhDVlFBS1hTQ0dtOUhzZTJJYmlLU0VwR0tZYitnRnhuNjRLSUJZNDg1SWJVRW9rRy81U3ZpbEc3RkJFdkdWVHJHSTY1RmNVK1ErZitSTDgyQzVTdmlsRzdGQkV2UENoSHpjaTY3SDhoMXNQNWpkN25MK3QyR2JCd1dwQkVacGlZTGlmb3RKZVFJWW93UkZNbGk2VHBaUEplNzFjVUxLdzdpTFp5ajVXaXNaekJYMXV2ZjJPNUlSaERZai9GSmtYNWNUR3YvV1hpaXVrMUpFdUxVaGVFa2d4UFVqaURQUlFXc2hmNXNJV21ibnFDYi84ays4c2I1QSt6YmFIU0EzSkg4Rk0zeGhnUU93d1V4WTAvaDZnczZRekhCcWhCMXVSY3Z0M2ROTVFKcG50d1RDak1yaVIzSjd1YXRNdTJGQnFoNjRYdjZ2ZDRrNWE1RStmWmN2Q2hhQ0kyRi9iQ2ppSk9jQnkwd2grbWcyajhsK3NyVzlnWGZwclQxT1NNaEdyUTNGcGFvRnVNc1lnTkR0WStDc1B5dTVrS0p0THhiWVZONW5tLytCMkhsSnVNdDdTN3V6cStjNU9JUlBLajVhMDBwOWNXWDM2IiwiaWF0IjoxNjc2NjI2NTI4LCJleHAiOjE2NzY2MjY4Mjh9.pBq8lcdDaylEgzfBSxi65TjUutmxw5Vee065IdyxexA";
const instance = axios.create({
  baseURL: 'https://bibomart.com.vn/camnang'
});

instance.interceptors.request.use(function (config) {
  return config;
});
instance.interceptors.response.use((response) => {
    return response.data
}, error => {
  return Promise.resolve({ error });
  // window.localStorage.setItem('errornetwworkmsg', error);
  // return window.location.href = '/404.html';
})

export default instance;